function isScrolledIntoView(elem) {

    var $elem = $(elem);
    var $window = $(window);
    if ($elem.offset() != undefined) {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();
        return (((elemBottom - 750) <= (docViewBottom)));
    }
}

function ChangeHashedStringParamValue(params, removedParam, newValue) {

    if (params != undefined && params.length > 0) {

        var splitStr = (removedParam + "=");
        var newParamsArray = params.split(splitStr);

        if (newParamsArray.length >= 2) {
            var firstPartOfParams = newParamsArray[0];
            var secondPartOfParams = "";
            var beginCalc = false;
            for (var i = 0; i < newParamsArray[1].length; i++) {

                if (beginCalc) {
                    secondPartOfParams += newParamsArray[1][i];
                }

                if (newParamsArray[1][i] == "&") {
                    beginCalc = true;
                }
            }

            params = firstPartOfParams + removedParam + "=" + newValue + "&" + secondPartOfParams;
        }
    }

    return params;
}

function GetQuickLookEvents() {
    $("#QuickLookModal .SmallProductImages img").live("click", function () {
        var ImageIndex = $(this).index();

        $("#QuickLookModal .ProductDetailImages ul li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).removeClass("gizli");
                $(this).find("a img").attr("src", $(this).find("a img").data("src"));
            }
            else {
                $(this).addClass("gizli");
            }
        });

        $("#QuickLookModal .SmallProductImages img").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("Selected");
            } else {
                $(this).removeClass("Selected");
            }
        });
    });
}

// Filtre kısmında kategorilerin menüden çekilip listelenmesini sağlayan fonksiyon(önceden bu şekilde çalışıyordu)
function GetLeftCatalogList() {

    //#region Kateogri filtresi kısmının eski hali
    //$curCatalogOld = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");

    //if ($curCatalogOld.length > 0) {

    //    $curULOld = $curCatalogOld.closest(".itemsWrapper").closest("li").first().clone();

    //    if ($curULOld.length < 1) {
    //        $curULOld = $curCatalogOld.closest("li").first().clone();
    //    }

    //    $("#SubCatNavs").html("");
    //    $("#SubCatNavs").append($curULOld);

    //    $selectedCatsx = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");
    //    $selectedCatsOld = $("#SubCatNavs a[data-rel='" + $("#PID").val() + "']");

    //    $selectedCatsOld.css("font-weight", "bold");
    //    $selectedCatsOld.css("color", "#797979");

    //    if ($selectedCatsOld.parent().parent().parent().hasClass("ListWrapper")) {
    //        $selectedCatsOld.parent().addClass("opened");
    //    } else {
    //        $selectedCatsOld.parent().closest("div").parent().addClass("opened");
    //    }
    //}

    //$("#SubCatNavs>li .itemsWrapper .ListWrapper>ul>").each(function () {
    //    if ($(this).find("div ul li").length == 0) {
    //        $(this).addClass("hidePlusIcon");
    //    }
    //});

    //#endregion

    //#region Kategori filtresi kısmının yeni hali 02.10.2024
    // Tüm kategorileri Mainmenu'den alıp SubCatNavsNew'e kopyalıyoruz
    $("#SubCatNavsNew").html($(".Mainmenu").html());

    var $curCatalog = $("#SubCatNavsNew a[data-rel='" + $("#PID").val() + "']");

    //console.log("curCatalog: " + $curCatalog.text());

    if ($curCatalog.length > 0) {
        // Tüm üst kategorileri kapat
        $("#SubCatNavsNew li").each(function () {
            $(this).find(".itemsWrapper").first().addClass("hide");
        });

        // Seçili kategoriyi bold yap
        $curCatalog.css('font-weight', 'bold');

        $curCatalog.parents("li").children(".itemsWrapper").removeClass("hide");

        // Sadece seçili kategorinin altındaki itemsWrapper'a hide ekle - FS#14557
        $curCatalog.closest("li").children(".itemsWrapper").addClass("hide");

        // Seçili kategoriye ait tüm üst kategorileri aç
        $curCatalog.parents("li").addClass("opened").removeClass("toggle-minus");

        // FS#14557
        $curCatalog.closest("li").removeClass("opened").addClass("toggle-minus");

        $("#SubCatNavsNew>li:not(.opened)").remove();
    }

    // Plus icon'u gizlemek için
    $("#SubCatNavsNew>li .itemsWrapper .ListWrapper>ul>").each(function () {
        if ($(this).find("div ul li").length == 0) {
            $(this).addClass("hidePlusIcon");
        }
    });
    //#endregion

    FixedLeftBar();
}

function FixedLeftBar() {
    $(window).scroll(function () {
        if ($("body").hasClass("Scrolled")) {
            //$("#SubCatNavs").addClass("FixedLeftBar");
            $("#SubCatNavsNew").addClass("FixedLeftBar");
        } else {
            //$("#SubCatNavs").removeClass("FixedLeftBar");
            $("#SubCatNavsNew").removeClass("FixedLeftBar");
        }
    });
}

// Filtre kısmındaki kategoriler seçildiğinde alt kategorilerin açılıp kapanmasını sağlayan fonksiyon
function ToggleLeftBarItems() {
    if ($(window).width() > 767) {
        $(".itemsWrapper > .ListWrapper > ul > li").live("click", function (e) {
            $(this).toggleClass("opened");
            $(this).find(".itemsWrapper").removeClass("hide");
            $(this).siblings("li").removeClass("opened");
            e.stopImmediatePropagation();
        });
    }
}

function ToggleLeftBar() {
    //$(".FilterForm .filterLink").live("click", function () {
    //    $(this).parent().find(".FilterBoxes").slideToggle();
    //    $(this).toggleClass("toggle-minus");
    //});

    $(".FilterForm .filterLink").live("click", function () {
        if ($(this).hasClass("toggle-minus")) {
            $(this).removeClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").css("display", "none");
        }
        else {
            $(this).addClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").css("display", "block");
        }
    });

    $("#SubCatNavsNew > li > a").live("click", function (e) {
        $(this).parent().find(".itemsWrapper").toggleClass("hide");
        $(this).parent().toggleClass("toggle-minus");
        e.preventDefault;
        return false;
    });

    // İlk renk seçiminde 'Ürün Grubu' alanının açılması yerine 'Renk' alanının açılması için eklendi
    //console.log("Eleman sayısı: ", $("#ColorFilters > li.selected").length);
    if ($("#ColorFilters > li.selected").length > 0) {
        $("#ColorFilters").parent().css("display", "block");
        $("#ColorFilters").parent().parent().children(".filterLink").addClass("toggle-minus");
    }
}

function SetPriceSlider() {
    var IsAutoScrollOpen = Boolean($("#AutoScroll").val());



    if ($(".CategoryLeftBar").length > 0) {
        var slider = document.getElementById('PriceSlider');
        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var maxFirst = $("#MaxPriceFirst").val();
        if (maxFirst) {
            var maxFirstFloat = parseFloat(maxFirst);
        }
        var currencySymbol = $("#CurrencySymbol").val();

        if (slider) {
            noUiSlider.create(slider, {
                start: [min, max],
                connect: true,
                step: 1,
                range: {
                    'min': parseInt(min),
                    'max': parseInt(max)
                }
            });

            slider.noUiSlider.on('change', function () {
                var values = slider.noUiSlider.get();
                $("#MinPrice").val(Math.round(values[0]));
                $("#MaxPrice").val(Math.round(values[1]));
                $("#prc").val(Math.round(values[0]) + "-" + Math.round(values[1]));

                if (IsAutoScrollOpen) {
                    $(".Products .ProductList.grid-wrapper").html("");
                }              

                window.location.hash = compress($("form#FilterForm").serialize());

                if ($("#FilterForm:visible").length > 0 && isMobile(true)) {
                    setTimeout(function () {
                        $("#FilterForm").slideToggle();
                    }, 400);
                }
            });

            slider.noUiSlider.on('update', function () {
                var values = slider.noUiSlider.get();
                $("#MinPriceInput").val(Math.round(values[0]));
                $("#MaxPriceInput").val(Math.round(values[1]));
                if (maxFirst && (maxFirstFloat != values[1] || values[0] > 0)) {
                    $("#prc").val(Math.round(values[0]) + "-" + Math.round(values[1]));
                    $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + " - " + Math.round(values[1]) + " " + currencySymbol);
                }
            });
        }

        // Inputlar değiştiğinde slider'ı güncelle
        $('#MinPriceInput, #MaxPriceInput').on('change', function () {
            var newMin = parseInt($("#MinPriceInput").val());
            var newMax = parseInt($("#MaxPriceInput").val());

            //alert("newmin: " + newMin + "newMax: " + newMax);

            // Geçerli bir min ve max değerine sahip olup olmadığımızı kontrol edelim
            if (!isNaN(newMin) && !isNaN(newMax) && newMin <= newMax) {
                //slider.noUiSlider.updateOptions({
                //    connect: true,
                //    step: 1
                //    //,range: {
                //    //    'min': newMin,
                //    //    'max': newMax
                //    //}
                //});

                slider.noUiSlider.set([newMin, newMax]);
                $("#MinPrice").val(newMin);
                $("#MaxPrice").val(newMax);

                if (IsAutoScrollOpen) {
                    $(".Products .ProductList.grid-wrapper").html("");
                }

                window.location.hash = compress($("form#FilterForm").serialize());

                if ($("#FilterForm:visible").length > 0 && isMobile(true)) {
                    setTimeout(function () {
                        $("#FilterForm").slideToggle();
                    }, 400);
                }
            } else {
                alert('Lütfen geçerli bir minimum ve maksimum değer girin.');
            }
        });
    }
}

function GetQuickLookModal(ProductID, ColorID) {

    $Modal = $("div#QuickLookModal");

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
        data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
        success: function (dt) {
            $("div#QuickLookModal .modal-body").html(dt);
            $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");
        }
    });

    $Modal.modal("show");

    return false;
    e.preventDefault();
}

function IsFollowCatagory() {

    if ($(".PrdImgsBox div .QuickLookLikeBtn").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".PrdImgsBox .QuickLookLikeBtn").addClass("passiveFavorite");
        $(".PrdImgsBox .QuickLookLikeBtn").removeClass("activeFavorite");
        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".PrdImgsBox div .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-productidlike") == item["ProductID"] && $(this).attr("data-coloridlike") == item["ColorID"];
            });



            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.removeClass("passiveFavorite");
                followItem.addClass("activeFavorite");

                if (followItem.hasClass("activeFavorite")) {
                    //followItem.css("background-image", "url(/Images/OXNW/like_full.png)");
                    followItem.children("img").attr("src", "/Images/JMK/Icons/dolukalp.png");
                }
            }
        }
    };




}

function AddToFavoriteNewCt() {

    $(".PrdImgsBox div .QuickLookLikeBtn.passiveFavorite").live("click", function () {
        $That = $(this);
        var ProductID = $(this).attr("data-productidlike");
        var ColorID = $(this).attr("data-coloridlike");
        var ProductCode = $(this).attr("data-productcode");
        var ProductName = $(this).attr("data-productname");
        var ColorName = $(this).attr("data-colorname");
        var price = parseFloat($(this).attr("data-amount"));
        var priceOld = parseFloat($(this).attr("data-amountPsf"));
        var discount = $(this).attr("data-discount");
        var category1 = $(this).attr('data-category1');
        var category2 = $(this).attr('data-category2');
        var category3 = $(this).attr('data-category3');
        var catID = $(this).attr('data-catID');
        var quantity = $(this).attr('data-quantity');
        var itemListName = $(this).attr('data-itemListName');

        discount = priceOld - price;
        if (price == priceOld) {
            discount = 0;
        }

        var amount = price;
        if (amount == 0) {
            amount = priceOld;
        }
        var value = parseFloat(amount);


        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    var storedCatalog = localStorage.getItem('selectedCatalog');
                    var storedCatalogID = localStorage.getItem('selectedCatalogID')

                    window.dataLayer = window.dataLayer || [];
                    if (window.dataLayer) {
                        try {
                            window.dataLayer.push({
                                event: "add_to_wishlist",
                                ecommerce: {
                                    currency: 'TRY',
                                    value: value,
                                    items: [
                                        {
                                            item_id: ProductCode,
                                            item_name: ProductName,
                                            affiliation: category1,
                                            coupon: "",
                                            currency: 'TRY',
                                            discount: discount,
                                            index: 0,
                                            item_brand: 'JMK',
                                            item_category: category1,
                                            item_category2: category2,
                                            item_category3: category3,
                                            item_list_id: parseInt(storedCatalogID),
                                            item_list_name: storedCatalog,
                                            item_variant: ColorName,
                                            location_id: 'İZ',
                                            price: priceOld,
                                            quantity: 1
                                        }
                                    ]
                                }
                            });
                        } catch (e) {

                        }
                    }

                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                        if ($That.hasClass("activeFavorite")) {
                            $That.children("img").attr("src", "/Images/JMK/Icons/dolukalp.png");
                        }
                        //#region Related Datalayer Add To Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                    }
                    else if (dt.Sonuc == false) {
                        //alert('Favorilere eklemek için giriş yapınız!');
                        $("#LoginRegisterModal").modal("show");

                        // Eğer script daha önce eklenmediyse, modal içine ekle
                        if ($("#LoginRegisterModal .cf-turnstile-script").length === 0) {
                            var turnstileScript = document.createElement("script");
                            turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
                            turnstileScript.async = true;
                            turnstileScript.defer = true;
                            turnstileScript.className = "cf-turnstile-script";

                            // Turnstile scriptini modal-body içine ekle
                            document.querySelector("#LoginRegisterModal .modal-body").appendChild(turnstileScript);
                        }
                        var memberlessBtn = document.querySelector(".ContinueWithoutMember");
                        if (memberlessBtn) {
                            memberlessBtn.remove();
                        }
                    }
                },
                error: function (httpObj, textStatus) {

                    //if (httpObj.status == 401) {
                    //    alert('Favorilere Eklemek için giriş yapınız.');
                    //}
                    //else {
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    //}
                }
            });
        }
    });
}

function removeFavoriteNewCt() {

    $(".PrdImgsBox div .activeFavorite").live("click", function () {
        $That = $(this);
        var ProductID = $(this).attr("data-productidlike");
        var ColorID = $(this).attr("data-coloridlike");

        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'productID=' + ProductID + '&colorID=' + ColorID + '&isDetail=true',
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                        if ($That.hasClass("passiveFavorite")) {
                            $That.children("img").attr("src", "/Images/JMK/Icons/kalp.png");
                        }
                        //#region Related Datalayer Remove From Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                    }
                },
                error: function (httpObj, textStatus) {
                    if (httpObj.status == 401) {
                        alert('Favorilerden çıkartmak için giriş yapınız.');
                    }
                    else {
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }
                }
            });
        }
    });
}

function CarouselLazyEvent() {
    $('.ProductList .Prd .PrdImgsBox .carousel.slide').on('slid.bs.carousel', function (event) {
        var hasAttr = $(this).find(".active img").attr("data-src");

        if (typeof hasAttr !== typeof undefined && hasAttr !== false) {
            var nextImg = $(this).find(".active img").attr("data-src");
            $(this).find(".active img").removeAttr("data-src");
            $(this).find(".active img").attr("src", nextImg);
        }
    });
}

function FillFilterItems(params) {

    var nmVL = params.split("&");
    var isFilterParam = false;
    for (var i = 0; i < nmVL.length; i++) {

        var nmVL2 = nmVL[i].split("=");

        for (var j = 0; j < nmVL2.length; j++) {

            if (nmVL2[0] == "u") {

                $("select#u option").removeAttr("selected");
                $("select#u option[value='" + nmVL2[1] + "']").prop("selected", true);

                $("#PrdItemNo input, #PrdItemNo label").removeAttr("checked");
                $("#PrdItemNo input, #PrdItemNo label").removeClass("checked");
                $("#PrdItemNo input, #PrdItemNo label").removeClass("c_on");

                var $checked = $("#PrdItemNo input[value='" + nmVL2[1] + "']");
                $checked.prop("checked", true);

                $checked.parent().find("label").addClass("checked");
                $checked.parent().find("label").addClass("c_on");
                $(".FlinkItemCount").text($checked.parent().find("label").text());
            }

            if (nmVL2[0] == "o") {

                $("#PrdSort input, #PrdSort label").removeAttr("checked");
                $("#PrdSort input, #PrdSort label").removeClass("checked");
                $("#PrdSort input, #PrdSort label").removeClass("c_on");

                var $checked = $("#PrdSort input[value='" + nmVL2[1] + "']");
                $checked.prop("checked", true);

                $checked.parent().find("label").addClass("checked");
                $checked.parent().find("label").addClass("c_on");
                $(".fLinkSortNo").html($checked.parent().first("label").text() + "<div class='plus-Icon'></div>");
            }

            if (nmVL2[0] == "c") {
                var selectedColor = nmVL2[1]; // Hash'teki color değerleri alınır
                var singleColorName = ""; // Filtrede tek bir renk kaldığı zaman banner adına yazılacak
                if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
                    var selectedColors = selectedColor.split(',');
                    isFilterParam = true;
                    $.each(selectedColors, function (key, value) {
                        var $checked = $("#ColorFilters input[value='" + value + "']");
                        $checked.parent().addClass("selected");
                        $checked.attr("checked", "checked");
                        var colorName = $checked.attr("data-colorname");
                        var $label = $checked.next("a").children("label");
                        $label.addClass("c_on");

                        /* Filtrelerin Text ile gösterilmesi ::  Mevcut Filtre varsa ekler Renk ::  Begin*/
                        if ($("#FilterForm .FilteredItems ul li[data-id='c-" + value + "']").length == 0) {
                            $("#FilterForm .FilteredItems ul").append("<li class='color'  data-id=c-" + value + "><span>Renk:</span>" + colorName + "</li>")
                        }
                        /* Filtrelerin Text ile gösterilmesi ::  Mevcut Filtre varsa ekler Renk ::  Begin*/

                        singleColorName = colorName;
                    });
                }
                var urlSplit = window.location.href.split("#");
                var splitMax = urlSplit[0].split("/"); //
                // Url rakam ile mi bitiyor ---> Tek renk katalog giibi davrandığı için bu kontrol eklenmiştir.
                var isnumber = Number.isInteger(parseInt(splitMax[splitMax.length - 1]));
                if (isnumber && urlSplit.length > 1) {
                    var Params = urlSplit[1].split("&");
                    for (var i = 0; i < Params.length; i++) {
                        if (Params[i].split("=")[0] == "c") {
                            var colorids = Params[i].split("=")[1].split(",");
                            if (colorids.length > 1) {
                                $("#CategoryBannerFilterColorName").html("");
                                $("#breadCrumbColor").html("");
                            }
                        }
                    }
                }

            }

            if (nmVL2[0] == "s") {
                var selectedSize = nmVL2[1]; // Hash'teki size değerleri alınır
                if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
                    var selectedSize = selectedSize.split(',');
                    isFilterParam = true;
                    $.each(selectedSize, function (key, value) {
                        var $size = $("#Sizes input[value='" + value + "']");
                        var $curLabel = $size.siblings("label").addClass("c_on");
                        $size.attr("checked", "checked");
                        /* Filtrelerin Text ile gösterilmesi :: Mevcut Filtre varsa ekler Renk ::  Begin*/
                        var sizeName = $size.attr("data-rel");
                        if ($("#FilterForm .FilteredItems ul li[data-id='s-" + value + "']").length == 0) {
                            $("#FilterForm .FilteredItems ul").append("<li class='size'  data-id=s-" + value + "><span>Beden:</span>" + sizeName + "</li>")
                        }
                        /* Filtrelerin Text ile gösterilmesi :: Mevcut Filtre varsa ekler Beden ::  Begin*/

                    });
                }
            }

            if (nmVL2[0] == "gn") {
                var selectedGender = nmVL2[1]; // Hash'teki gender değerleri alınır
                if (selectedGender != null && selectedGender != "" && selectedGender != undefined) {
                    var selectedGender = selectedGender.split(',');
                    isFilterParam = true;
                    $.each(selectedGender, function (key, value) {
                        var $gender = $("#Genders input[value='" + value + "']");
                        var $curLabel = $gender.siblings("label").addClass("c_on");
                        $gender.attr("checked", "checked");
                        /* Filtrelerin Text ile gösterilmesi :: Mevcut Filtre varsa ekler Renk ::  Begin*/
                        var genderName = $gender.attr("data-rel");
                        if ($("#FilterForm .FilteredItems ul li[data-id='gn-" + value + "']").length == 0) {
                            $("#FilterForm .FilteredItems ul").append("<li class='size'  data-id=gn-" + value + "><span>Cinsiyet:</span>" + genderName + "</li>")
                        }
                        /* Filtrelerin Text ile gösterilmesi :: Mevcut Filtre varsa ekler Beden ::  Begin*/

                    });
                }
            }

            if (nmVL2[0] == "prc") {


                var $price = nmVL2[1].split("-");
                var minPrice = $price[0];
                var maxPrice = $price[1];

                if (minPrice != undefined && maxPrice != undefined) {
                    isFilterParam = true;
                    var leftPercent = parseInt(minPrice) / 1200 * 100;
                    var rightPercent = parseInt(maxPrice) / 1200 * 100;

                    leftPercent = Math.min(leftPercent, 100);
                    rightPercent = Math.min(rightPercent, 100);
                    /* Fiyat filtresinin ayarlanması*/
                    //$(".noUi-origin")[0].style.left = leftPercent + "%";
                    $("#MinPrice").val(minPrice);
                    //$(".noUi-origin")[1].style.left = rightPercent + "%";
                    $("#MaxPrice").val(maxPrice)
                    $(".priceView").html(minPrice + " ₺ -" + maxPrice + " ₺");
                    //$("#prc").val(minPrice + " - " + maxPrice);

                    /* Filterinin text ile gösterilmesi :: Filtre Eklenmesi Fiyat :: Begin*/
                    if ($("#FilterForm .FilteredItems ul .price").length == 0) {
                        $("#FilterForm .FilteredItems ul").append("<li class='price'><span>Fiyat :</span>" + minPrice + " - " + maxPrice + "</li>");
                    } else if ($("#FilterForm .FilteredItems ul .price").length == 1) {
                        $("#FilterForm .FilteredItems ul .price").html("<span>Fiyat :</span>" + minPrice + " - " + maxPrice);
                    }
                    /* Filterinin text ile gösterilmesi :: Filtre Eklenmesi Fiyat :: End*/
                }
            }

            // Renk Beden Fiyat parametrelerinden herhangi biri varsa tümünü kaldır butonu görünsün
            if (isFilterParam) {
                if ($(".removeAllFilter").css("display") == "none") {
                    $(".removeAllFilter").css("display", "block")
                }
            }

            // Herhangi bir filtre kalmadıysa Tüm seçimi kaldır yazısı kaldırılsın
            if ($(".FilteredItems ul").find("li").length == 0) {
                $(".removeAllFilter").css("display", "none");
            }

            if (nmVL2[0] == "g") {

                $("#GridIcons input, #GridIcons label").removeAttr("checked");
                $("#GridIcons input, #GridIcons label").removeClass("checked");
                $("#GridIcons input, #GridIcons label").removeClass("c_on");

                var $checked = $("#GridIcons input[value='" + nmVL2[1] + "']");
                $checked.prop("checked", true);

                $checked.parent().find("label").addClass("checked");
                $checked.parent().find("label").addClass("c_on");

                //$("#GridIcons .mGridIcons .gi").removeClass("uclu-grid-active").removeClass("ikili-grid-active").removeClass("dortlu-grid-active");
                //$("#GridIcons .mGridIcons .gi").removeClass("uclu-grid-passive").removeClass("ikili-grid-passive").removeClass("dortlu-grid-passive");

                if (nmVL2[1] == 3) {
                    $checked.parent().find(".mGridIcons .gi").addClass("uclu-grid-active");
                    $("#GridIcons .mGridIcons-2-2 .gi").removeClass("ikili-grid-active").addClass("ikili-grid-passive");
                    //console.log("uclu");
                }
                else if (nmVL2[1] == 2) {
                    $checked.parent().find(".mGridIcons .gi").addClass("ikili-grid-active");
                    $("#GridIcons .mGridIcons-4 .gi").removeClass("uclu-grid-active").addClass("uclu-grid-passive");
                    //console.log("ikili");
                }
                else if (nmVL2[1] == 4) {
                    $checked.parent().find(".mGridIcons .gi").addClass("dortlu-grid-active");
                    $("#GridIcons .mGridIcons-5 .gi").removeClass("uclu-grid-active").removeClass("uclu-grid-passive");
                    //console.log("dortlu");
                }

            }

            if (nmVL2[0] == "so") {

                var $checked = $("#SoldOutOp input[value='" + nmVL2[1] + "']");

                $checked.parent().find("label").removeAttr("checked");
                $checked.parent().find("label").removeClass("checked");
                $checked.parent().find("label").removeClass("c_on");
            }

            var filterSelector = "none";
            if (nmVL2[0] == "sc") filterSelector = "sc";
            if (nmVL2[0] == "c") filterSelector = "cl";
            if (nmVL2[0] == "b") filterSelector = "mr";
            if (nmVL2[0] == "sty") filterSelector = "sty";
            if (nmVL2[0] == "s") filterSelector = "sz";
            if (nmVL2[0] == "gn") filterSelector = "gn";

            if (filterSelector != "none") {

                $(".fil" + filterSelector + " label").removeAttr("checked");
                $(".fil" + filterSelector + " input").removeClass("checked");
                $(".fil" + filterSelector + " label").removeClass("c_on");

                var ParamValues = nmVL2[1].split(",");

                for (var q = 0; q < ParamValues.length; q++) {

                    var $checked = $(".fil" + filterSelector + " input[value='" + ParamValues[q] + "']");
                    $checked.prop("checked", true);

                    $checked.parent().find("label").addClass("checked");
                    $checked.parent().find("label").addClass("c_on");

                    $(".fil" + filterSelector).closest("div").find(".RemoveFilter").show();
                }
            }
        }

    }


}

var isNewRequestAllowed = true;
var isFirstLoad = false;
var LoadPage = 1;


//ürün listesi açılır açılmaz datalayera push yapacak script (view_item_list)
function ScrollAllGetProduct() {
    var productList = $(".contentTopSpace .ProductColumn .PrdContainer .Products .ProductList");
    if (productList.length > 0) {
        var products = productList.find(".PrdItemBox");
        var productListAll = [];

        products.each(function (index, element) {
            var ProductCode = $(this).attr("data-productcode");
            var ProductName = $(this).attr("data-productname");
            var ColorName = $(this).attr("data-colorname");
            var price = parseFloat($(this).attr("data-amount"));
            var priceOld = parseFloat($(this).attr("data-amountPsf"));
            var discount = $(this).attr("data-discount");
            var dataProductListPosition = $(this).attr("data-listposition");
            var category1 = $(this).attr('data-category1');
            var category2 = $(this).attr('data-category2');
            var category3 = $(this).attr('data-category3');
            var catID = $(this).attr('data-catID');
            var itemListName = $(this).attr('data-itemListName');


            discount = priceOld - price;
            if (price == priceOld) {
                discount = 0;
            }

            var amount = price;
            if (amount == 0) {
                amount = priceOld;
            }

            var value = parseFloat(amount);

            var storedCatalog = localStorage.getItem('selectedCatalog');


            var viewItem = {
                item_id: ProductCode,
                item_name: ProductName,
                affiliation: category1,
                coupon: "",
                currency: 'TRY',
                discount: discount,
                index: parseInt(dataProductListPosition),
                item_brand: 'JMK',
                item_category: category1,
                item_category2: category2,
                item_category3: category3,
                item_list_id: parseInt(catID),
                item_list_name: storedCatalog,
                item_variant: ColorName,
                location_id: 'İZ',
                price: priceOld,
                quantity: 1
            };

            productListAll.push(viewItem);
        });

        // Tüm ürünleri aktarır
        window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
            try {
                window.dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: productListAll
                    }
                });
            } catch (e) {

            }
        }
    }

}

//ürün listesinde ürüne tıklandığı anda datalayere push yapacak script (select_item)
function ProductListSelectDetailClick() {

    var productList = $(".contentTopSpace .ProductColumn .PrdContainer .Products .ProductList");

    var products = productList.find(".PrdImgsBox .carousel");

    products.click(function () {

        var ProductCode = $(this).attr("data-productcode");
        var ProductName = $(this).attr("data-productname");
        var ColorName = $(this).attr("data-colorname");
        var price = parseFloat($(this).attr("data-amount"));
        var priceOld = parseFloat($(this).attr("data-amountPsf"));
        var discount = $(this).attr("data-discount");
        var dataProductListPosition = $(this).attr('data-listposition');

        var category1 = $(this).attr('data-category1');
        var category2 = $(this).attr('data-category2');
        var category3 = $(this).attr('data-category3');

        var catID = $(this).attr('data-catID');

        localStorage.setItem('selectedCatalogID', catID);

        var itemListName = $(this).attr('data-itemListName');

        var url = window.location.pathname;
        var urlParts = url.split('/');
        var catalogName = urlParts[urlParts.length - 1];

        localStorage.setItem('selectedCatalog', catalogName);

        discount = priceOld - price;

        if (price == priceOld) {
            discount = 0;
        }

        var amount = price;

        if (amount == 0) {
            amount = priceOld;
        }

        var value = parseFloat(amount);
        var storedCatalog = localStorage.getItem('selectedCatalog');
        var storedCatalogID = localStorage.getItem('selectedCatalogID')

        window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
            try {
                window.dataLayer.push({
                    event: "select_item",
                    ecommerce: {
                        items: [{
                            item_id: ProductCode,
                            item_name: ProductName,
                            affiliation: category1,
                            coupon: "",
                            currency: 'TRY',
                            discount: discount,
                            index: parseInt(dataProductListPosition),
                            item_brand: 'JMK',
                            item_category: category1,
                            item_category2: category2,
                            item_category3: category3,
                            item_list_id: parseInt(storedCatalogID),
                            item_list_name: storedCatalog,
                            item_variant: ColorName,
                            location_id: 'İZ',
                            price: priceOld,
                            quantity: 1
                        }]
                    }
                });
            } catch (e) {

            }
        }


    });

}

// SolUstBosluklu alanında birden fazla badge varsa alt alta gelmesi için
function BadgeBottomEdit() {
    var products = document.querySelectorAll(".PrdContainer .Products .ProductList .Prd");


    if (products && products.length > 0) {
        products.forEach(function (product) {
            var badges = product.querySelectorAll(".badge-left-top-padding");

            if (badges && badges.length > 1) {
                badges.forEach(function (badge, index) {
                    if (index > 0) {
                        if (window.innerWidth > 992) {
                            badge.style.top = (20 + (index * 30)) + "px";
                        }
                        else {
                            badge.style.top = (15 + (index * 25)) + "px";
                        }
                    }
                });
            }
        });
    }
}

$(document).ready(function () {
    AddToFavoriteNewCt();
    removeFavoriteNewCt();
    IsFollowCatagory();
    CarouselLazyEvent();
    ScrollAllGetProduct()
    ProductListSelectDetailClick();

    $(window).resize(function () {
        if (isMobile(true)) {
            $(".isMobileInput").val(true);
        } else {
            $(".isMobileInput").val(false);
        }
    });

    // instagram dan yönlendirme aldığında mobil görünümde 3 lü liste sayfası geldiği için görsel hata oluşmaktadır.
    if (window.location.href.indexOf("utm_source=") > 0 && isMobile(true)) {
        var ct = $("#ct").val();
        var red = "#prc=&g=2&ct=" + ct + "&u=48";
        window.location.href = window.location.href + red;
    }

    //$('.multi-item-carousel').carousel({
    //    interval: false,
    //    ItemOnPage: 6,
    //});

    //$('.multi-item-carousel .item').each(function () {
    //    var next = $(this).next();
    //    if (!next.length) {
    //        next = $(this).siblings(':first');
    //    }
    //    next.children(':first-child').clone().appendTo($(this));

    //    if (next.next().length > 0) {
    //        next.next().children(':first-child').clone().appendTo($(this));
    //    } else {
    //        $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
    //    }
    //});

    var IsAutoScrollOpen = Boolean($("#AutoScroll").val());

    if (IsAutoScrollOpen) {

        $(".Pages").hide();
    }

    function GetHashParamValue(param) {
        if (window.location.hash.indexOf("&" + param + "=") == -1) {
            return "";
        }

        var nmVL = window.location.hash.split("&" + param + "=");
        return nmVL[1].split("&")[0];
    }

    GetQuickLookEvents();
    GetLeftCatalogList(); // İlk kategori filtresi
    ToggleLeftBarItems();
    ToggleLeftBar();
    SetPriceSlider();
    BadgeBottomEdit();


    var ScrollContentID = "LastScrollTop" + $("#PID").val();
    var LastScrollTop = $.cookie(ScrollContentID);

    if (window.location.hash != undefined && window.location.hash.length > 0) {
        isFirstLoad = true;
        LoadPage = Number(GetHashParamValue("p"));
    }
    else {
        if ($(window).width() < 992) {
            setTimeout(function () {
                $('html, body').scrollTop(0);
            }, 1000);
        }
    }

    var grd = GetHashParamValue("g");
    var sld = GetHashParamValue("so");

    if ($(window).width() < 767 && grd != undefined && grd == "") {

        //$("#GridIcons input, #GridIcons label").removeAttr("checked");
        //$("#GridIcons input, #GridIcons label").removeClass("checked");
        //$("#GridIcons input, #GridIcons label").removeClass("c_on");

        var $checked = $("#GridIcons input[value='6']");
        $checked.closest("li.gr").find("label").addClass("c_on checked");

        $checked.prop("checked", true);

        //tükenenler için
        $("#SoldOutOp input, #SoldOutOp label").removeAttr("checked");
        $("#SoldOutOp input, #SoldOutOp label").removeClass("checked");
        $("#SoldOutOp input, #SoldOutOp label").removeClass("c_on");

        var $checked = $("#SoldOutOp input[value='6']");
        $checked.closest("li.gr").find("label").addClass("c_on checked");
        $checked.prop("checked", true);
    }

    $(window).bind('hashchange', function (e) {

        //hash değiştiğinde kategori açıklaması gizlensin
        if ($(".CatDescription").length > 0) {
            $(".CatDescription").remove();
        }

        var hs = window.location.hash;
        var params = hs.replace("#", "");

        if (hs == "#_=_") {

            window.location.hash = "";
            document.location.href = "";
        }

        if ($("form#FilterForm").length > 0 && $("#Tag").length == 0 || $("#CombineList").length > 0) {

            $gizlenecekSecim = $(".Products");
            //$gizlenecekSecim.css("opacity", "0.1");
            $(".AjaxLoader").show();

            FillFilterItems(params); // Url'deki filtre parametrelerinin filtre alanda işaretlenmesi

            //var NewGrid = GetHashParamValue("g");
            if (params == undefined || params == null || params == "") {
                existParams = compress($("form#FilterForm").serialize());
                params = existParams.replace("#", "");
            }

            if (params != undefined && params != null) {

                $(".AjaxLoader").show();
                isNewRequestAllowed = false;

                var defAdress = "/Home/GetProductList";

                if ($("#CombineList").length > 0) {
                    defAdress = "/Cat/Combines";
                }

                //calculate all loaded pages till current page
                if (isFirstLoad && LoadPage > 1) {
                    var uParam = GetHashParamValue("u");
                    if (uParam == undefined || uParam == "") {
                        uParam = 1;
                    }
                    else {
                        uParam = Number(uParam);
                    }

                    var newUParam = LoadPage * uParam;

                    params = ChangeHashedStringParamValue(params, "u", newUParam);
                    params = ChangeHashedStringParamValue(params, "p", 1);
                }
                var lastindex = 0;

                //console.log(params);
                if ($(window).width() < 991) {
                    params = params.replace("g=3", "g=2");
                }



                $.ajax({
                    type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p" + defAdress + ($("#sr").length > 0 ? "?sr=" + $("#sr").val() : ""),
                    data: params,
                    cache: false,
                    success: function (data) {

                        //$gizlenecekSecim.animate({
                        //    opacity: 1
                        //}, 500, function () {
                        //});
                        $(".AjaxLoader").hide();

                        isNewRequestAllowed = true;

                        if (IsAutoScrollOpen && !isFirstLoad) {

                            if ($(".ProductList .NotFound").length <= 0) {

                                //console.info($("#GridIcons li label.checked").parent().find("input").val())
                                //console.info($("#SoldOutOp li label.checked").parent().find("input").val())

                                //if($("#GridIcons li label.checked").parent().find("input").val() == 4){
                                //    $(".ProductColumn").removeClass("col-md-16");
                                //    $(".ProductColumn").addClass("col-md-19");
                                //} else {
                                //    $(".ProductColumn").removeClass("col-md-19");
                                //    $(".ProductColumn").addClass("col-md-16");
                                //}
                                $(".Products .ProductList.grid-wrapper").append(data);

                                BadgeBottomEdit();
                                //setBadgeCssTopValue();

                                var totalProductCount = $(".Products #ProductCountTotal").last().text();
                                $("#TotalSearchCount").html(totalProductCount);

                                $(".TotalProductCount").text("(" + totalProductCount + " Ürün)");


                                //$(".FilterForm .FilterBoxes").hide();
                            }

                            $(".Pages:first").html($(".Products .Pages:eq(2)").html());

                            $(".Products .Pages:gt(0)").remove();

                            if (IsAutoScrollOpen && $("#CombineList").length <= 0) {

                                $(".Pages").hide();
                            }

                            isFirstLoad = false;

                            lastindex = $(".Products .ProductList").length;

                            if (UseTagManager && lastindex != undefined) {
                                AddFilterEvent();
                                AddImpression('');
                                SendGaDataLayerVirtual();
                            }
                            if (defAdress == "/Home/GetProductList") {
                                //#region InsiderObject
                                var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
                                var InsiderObjectEnd = data.indexOf("-InsiderObject-->");

                                var InsiderObjectCode = data.slice(InsiderObjectBegin, InsiderObjectEnd).replace("<!--InsiderObject-", "").replace("-InsiderObject-->", "");
                                //console.log("InsiderObjectCode:" + InsiderObjectCode);

                                if (InsiderObjectCode != null && InsiderObjectCode != undefined && InsiderObjectCode != "") {
                                    window.insider_object = JSON.parse(InsiderObjectCode);
                                }
                                //#endregion InsiderObject
                            }
                        }
                        else {
                            //if ($("#GridIcons li label.checked").parent().find("input").val() == 4) {
                            //    $(".ProductColumn").removeClass("col-md-16");
                            //    $(".ProductColumn").addClass("col-md-19");
                            //} else {
                            //    $(".ProductColumn").removeClass("col-md-19");
                            //    $(".ProductColumn").addClass("col-md-16");
                            //}
                            $(".Products .ProductList.grid-wrapper").html(data);

                            var totalProductCount = $(".Products #ProductCountTotal").last().text();

                            BadgeBottomEdit();
                            //setBadgeCssTopValue();

                            $("#TotalSearchCount").html(totalProductCount);

                            isFirstLoad = false;

                            if (LastScrollTop != undefined && LastScrollTop.length > 0) {
                                LastScrollTop = Number(LastScrollTop);

                                $('html, body').animate({
                                    scrollTop: LastScrollTop
                                }, 500);

                                $.cookie(ScrollContentID, null, { expires: -1 });
                            }
                        }

                        // $(".ProductList .Prd .UseLazyLoad").Lazy();
                        CarouselLazyEvent();
                        if (params != undefined && params != null && params.includes("c=") && !window.location.href.includes("/en/")) {
                            $("head").append("<meta name='robots' content='noindex, nofollow'>");
                        }
                        //var $curWidth = $('.ProductListColorContainer div.ProductListColor:not(.passive)').closest(".Prd").find("a:first img").width();
                        var $curWidth = $('.PrdImgsBox:first').width();
                        //console.log($curWidth);
                        //$(".ProductList > div > div.PrdImgsBox .AddToCartArea").css('width', $curWidth);

                        if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {

                            $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");

                            //if ($("#GridIcons .gr input:checked:first").val() == "3") {

                            //    $(".PrdContainer .ProductList .Prd").removeClass("col-xs-24").addClass("col-xs-12");
                            //}
                            //else if ($("#GridIcons .gr input:checked:first").val() == "3") {

                            //    $(".PrdContainer .ProductList .Prd").removeClass("col-xs-12").addClass("col-xs-24");
                            //}
                        }
                    }
                });
            }
        }
    });

    var finished = false;

    //$('#ColorFilters > li.colorfilter a').click(function (event) {

    //    $li = $(this).closest("li");
    //    $label = $(this).find("label"); console.log("Seçilen Label;\n", $label);

    //    if ($li.find("input:checked").length > 0) {

    //        $li.find("input").removeAttr("checked");
    //        $li.removeClass("selected");
    //        $label.removeClass("c_on"); console.log("Seçilen Label 'c_on' class'ı silindi;\n");
    //    }
    //    else {
    //        $li.find("input").attr("checked", "checked");
    //        $li.addClass("selected");
    //        $label.addClass("c_on"); console.log("Seçilen Label 'c_on' class'ı eklendi;\n");
    //    }

    //    //$li.find("input").trigger("change");
    //});

    $(".RemoveFilter").live("click", function () {
        $(".RemoveFilter").trigger("change");

        $("#ColorFilters > li").removeClass("selected");
        //$("#ColorFilters > li > label").removeClass("c_on");
    });


    $(".p-card-img-wr").live("mouseover", function () {
        if ($(window).width() >= 991) {
            var id = $(this).attr("data-id");
            var itemNum = $(this).attr("data-num");

            if (id != undefined && id != "" && itemNum != undefined && itemNum != "") {
                $("#" + id + " .carousel-inner .item").removeClass("active");
                $("#" + id).find(".carousel-indicators li").removeClass("active");

                $("#" + id + " .carousel-inner .item").eq(itemNum).addClass("active");
                $("#" + id).find(".carousel-indicators li").eq(itemNum).addClass("active");
            }
        }
    })

    $(".product-card-grid-layout").live("mouseleave", function () {
        var id = $(this).find("a.p-card-img-wr").attr("data-id");

        $("#" + id + " .carousel-inner .item").removeClass("active");
        $("#" + id).find(".carousel-indicators li").removeClass("active");

        $("#" + id + " .carousel-inner .item").eq(0).addClass("active");
        $("#" + id).find(".carousel-indicators li").eq(0).addClass("active");
    });

    $("#GridIcons > li.gr input").on("click", function () {
        $curIput = $(this);
        $curLi = $(this).closest("li");
        $curLabel = $curLi.find("label:first");

        $("#GridIcons input").removeAttr("checked");
        $("#GridIcons label").removeClass("checked");
        $("#GridIcons label").removeClass("c_on");

        $curIput.attr("checked", "checked");
        $curLabel.addClass("c_on");

        var gParam = $curIput.val();

        if (gParam == "2") {
            $(".ProductList.grid-wrapper").addClass("Double");
            $(".ProductList.grid-wrapper").removeClass("Quad");

            if ($(window).width() > 767) {
                $(".ikili-grid-passive").addClass("ikili-grid-active").removeClass("ikili-grid-passive");
                $(".uclu-grid-active").addClass("uclu-grid-passive").removeClass("uclu-grid-active");
                $(".dortlu-grid-active").addClass("dortlu-grid-passive").removeClass("dortlu-grid-active");
            }
        }
        else if (gParam == "3") {
            $(".ProductList.grid-wrapper").removeClass("Double");
            $(".ProductList.grid-wrapper").removeClass("Quad");

            if ($(window).width() > 767) {
                $(".ikili-grid-active").addClass("ikili-grid-passive").removeClass("ikili-grid-active");
                $(".uclu-grid-passive").addClass("uclu-grid-active").removeClass("uclu-grid-passive");
                $(".dortlu-grid-active").addClass("dortlu-grid-passive").removeClass("dortlu-grid-active");
            }
        }
        else if (gParam == "4") {
            $(".ProductList.grid-wrapper").removeClass("Double").addClass("Quad");

            if ($(window).width() > 767) {
                $(".ikili-grid-active").addClass("ikili-grid-passive").removeClass("ikili-grid-active");
                $(".uclu-grid-active").addClass("uclu-grid-passive").removeClass("uclu-grid-active");
                $(".dortlu-grid-passive").addClass("dortlu-grid-active").removeClass("dortlu-grid-passive");
            }
        }
    });

    $('#ColorFilters > li input, #Styles > li input, #Departments > li input, #Sizes > li input, #Genders > li input, #PrdSort > li input, #PrdItemNo > li input, #SoldOutOp > li.gr input, .FilterForm .FilteredItems .removeAllFilter, .FilteredItems li').live("click", function (e) {

        $curIput = $(this);
        $curLi = $(this).closest("li");
        $curLabel = $curLi.find("label:first");
        //#region Filtrelerin Text ile gösterilmesi :: Silme işlemleri ::
        var newRemoveItems = false; // Yeni eklenen filtre itemleri ile işlem yapılıp yapılmadığı'nı tutar //form tetikleme

        // Tüm seçimi kaldıra tıklandıysa kategori sayfasına yönlendir.
        if ($(this).hasClass("removeAllFilter")) {
            $(".Products .ProductList.grid-wrapper").html("");
            $(".AjaxLoader").show();

            var lastCatUrl = "";
            var urlSplit = window.location.href.split("#")[0].split("/");
            var splittextCount = urlSplit.length;

            // Url rakam ile mi bitiyor ---> Tek renk katalog giibi davrandığı için bu kontrol eklenmiştir.
            var isnumber = Number.isInteger(parseInt(window.location.href.split("#")[0].split("/")[splittextCount - 1]));
            if (isnumber) {

                for (var i = 0; i < splittextCount - 2; i++) {
                    if (i == 0) {
                        lastCatUrl += urlSplit[i] + "//"
                    } else {
                        lastCatUrl += urlSplit[i] + "/"
                    }
                }
            } else {
                // Yönlendirmenin uzun sürme durumlarında kullanıcıya yükleniyor animasyonu
                lastCatUrl = window.location.href.split("#")[0]; // url bilgisi

                // Seçilen filtreleri temizler
                $("#FilterForm .FilteredItems").find("li").remove();
                $("#FilterForm .FilteredItems").find("p").css("display", "none");
                // Yönlendirme
            }

            window.location.href = lastCatUrl;
        }

        if ($(this).closest("div").hasClass("FilteredItems") == true && $(this).hasClass("removeAllFilter") == false) {
            var elementID = $(this).attr("data-id"); //  kaldırılmak istenen filtrenin Id değerine ulaş

            if (elementID == undefined) {// Fiyat filtresi

                $(".noUi-origin")[0].style.left = "0%"
                $("#MinPrice").val("80");
                $(".noUi-origin")[1].style.left = "100%"
                $("#MaxPrice").val("1200")
                $(".priceView").html("0 ₺ - 1200 ₺")
                $("#prc").val("0-1200");
                $(this).remove();

            } else {// Beden veya renk filtresi

                var removedItem = $("#" + elementID);// Hangi filtre kaldırılacak
                if (removedItem.is(':checked')) {
                    var listelement = removedItem.closest("li");
                    listelement.removeClass("selected");
                    listelement.find("input").removeAttr("checked");
                    listelement.find("label").removeClass("checked");
                    listelement.find("label").removeClass("c_on");
                    $(this).remove();
                }
            }

            $(".Products .ProductList.grid-wrapper").html(""); // Ürün listesini sil
            newRemoveItems = true;
        }
        //#endregion Filtrelerin Text ile gösterilmesi :: Silme işlemleri ::

        //#region Filtrelerin Text ile gösterilmesi :: Ekleme işlemleri Renk - Beden ::
        // Tıklanan filtre benden filtresi ise
        if ($(this).closest("ul").attr("id") == "Sizes") {
            if ($(".removeAllFilter").css("display") == "none") {// Tüm seçimi kaldır görünsün
                $(".removeAllFilter").css("display", "block")
            }
            // ilgili filtreyi listeye  ekle
            $("#FilterForm .FilteredItems ul").append("<li class='size' data-id=" + $curLi.find("input:first").attr("id") + "><span>Beden :</span>" + $(this).closest("input").attr("data-rel") + "</li>")
        } else if ($(this).closest("ul").attr("id") == "ColorFilters") {
            // Tıklanan filtre renk filtresi ise 
            if ($(".removeAllFilter").css("display") == "none") {// Tüm seçimi kaldır görünsün
                $(".removeAllFilter").css("display", "block")
            }
            // ilgili filtreyi listeye ekle
            if ($("#FilterForm .FilteredItems ul").find('[data-id=' + $curLi.find("input").attr("id") + ']').length == 0) {
                $("#FilterForm .FilteredItems ul").append("<li class='color'  data-id=" + $curLi.find("input:first").attr("id") + "><span>Renk:</span>" + $(this).closest("input").attr("data-colorName") + "</li>")
            }
        } else if ($(this).closest("ul").attr("id") == "Departments") {
            if ($(".removeAllFilter").css("display") == "none") {// Tüm seçimi kaldır görünsün
                $(".removeAllFilter").css("display", "block")
            }
            $("#FilterForm .FilteredItems ul").append("<li class='departman' data-id=" + $curLi.find("input:first").attr("id") + "><span>Ürün Grubu :</span>" + $(this).closest("input").attr("data-rel") + "</li>")

        }
        //#endregion Filtrelerin Text ile gösterilmesi :: Ekleme işlemleri Renk - Beden ::

        var GridVal = "";
        var SoldOutVal = "";

        if ($(this).closest("#SoldOutOp").length > 0) {

            $("#SoldOutOp input").removeAttr("checked");
            $("#SoldOutOp label").removeClass("checked");
            $("#SoldOutOp label").removeClass("c_on");

            SoldOutVal = "&so=" + $curIput.val();

            var soldOutValue = "0";
            soldOutValue = $(this).val();

            if (soldOutValue == "1") {
                soldOutValue = "0";
                $(this).val("0");

                $(this).parent().find("label").removeClass("checked");
                $(this).parent().find("label").removeClass("checked2");

            }
            else if (soldOutValue == "0") {
                soldOutValue = "1";
                $(this).val("1");

                $(this).parent().find("label").addClass("checked2");
            }

            if (IsAutoScrollOpen && SoldOutVal != sld) {
                $(".Products .ProductList.grid-wrapper").html("");
                sld = SoldOutVal;
            }
        }

        if ($(this).closest("#PrdSort").length > 0) {

            if ($curLabel.hasClass("checked")) {
                // Seçili olana tıklanırsa işlem yapmasın
            }
            else {
                SortVal = "&o=" + $curIput.val();
                $("#PrdSort input").removeAttr("checked");
                $("#PrdSort label").removeClass("checked");
                $("#PrdSort label").removeClass("c_on");

                $curIput.attr("checked", "checked");
                $curLabel.addClass("c_on");

                // TOdo: A çılan comboBox'ı gizlemek işlemi için düzeltme yapılacak.
                //$("#SortSelection").css("display", "none");
                //$("#SortSelection").parent().children(".filterLink").removeClass("toggle-minus");

                if ($(this).closest("#PrdSort").length > 0) {
                    //$(this).closest("#PrdSort").parent().hide();
                    //$(this).closest(".FilterSortBy").find(".filterLink").text($(this).find("label:first").text());
                }

                if (IsAutoScrollOpen) {
                    $(".Products .ProductList.grid-wrapper").html("");
                }
            }

        }

        if ($(this).closest("#Sizes").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest("#Genders").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest("#Styles").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest("#Departments").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest("#ColorFilters").length > 0) {

            //$("#ColorFilters input").removeAttr("checked");
            //$("#ColorFilters label").removeClass("checked");
            //$("#ColorFilters label").removeClass("c_on");

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest(".filcl").length > 0) {

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($(this).closest("#PrdItemNo").length > 0) {

            SortVal = "&u=" + $("input", $(this)).val();

            $("#PrdItemNo input").removeAttr("checked");
            $("#PrdItemNo label").removeClass("checked");
            $("#PrdItemNo label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on checked");

            $("#PrdItemNo").parent().hide();

            $(this).closest("#PrdItemNo").parent().hide();
            $(".FlinkItemCount").text($("input", $(this)).val());

            if (IsAutoScrollOpen) {
                $(".Products .ProductList.grid-wrapper").html("");
            }
        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if ($curLi.find("input:first").is(':checked')) {
            $curLi.find("input").attr("checked", "checked");
            $curLi.find("label:first").addClass("c_on");
        }
        else {
            $curLi.removeClass("selected");
            $curLi.find("input").removeAttr("checked");
            $curLi.find("label").removeClass("checked");
            $curLi.find("label").removeClass("c_on");

            $(".FilteredItems ul").find('[data-id=' + $curLi.find("input").attr("id") + ']').remove();;
        }

        //if ( !e.target.nodeName == "INPUT") {
        if (soldOutValue != undefined) {
            //console.log("soldOutValue_x");
            window.location.hash = compress($("form#FilterForm, form#CatFilterForm").closest("form").serialize() + "&so=" + soldOutValue);
        } else if (newRemoveItems == true) {
            window.location.hash = compress($("form#FilterForm, form#CatFilterForm").serialize());
        }
        else {
            //console.log("form_x");
            window.location.hash = compress($("form#FilterForm, form#CatFilterForm").serialize());
        }

        //e.preventDefault();
        //return;
        //}
        if (isMobile(true)) {
            // task no 6522
            $("#FilterForm").slideToggle();
        }


    });

    $("#ColorFilters li div.NoIndex").live("click", function () {

        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            window.location.href = href;
        }

    });

    //$("#ColorFilters > li > label, #ColorFilters > li input").live("click", function (e)
    //{
    //    e.preventDefault();
    //    return;
    //});

    var locationHashValue = window.location.hash;

    if ($("form#FilterForm").length > 0 && locationHashValue == "" && $("#sr").length == 0 && $("#Tag").length == 0) {

        var pgNo = "1";

        if ($('.Pages a.selected').length > 0) {

            pgNo = $('.Pages a.selected:first').attr("data-pgno");
        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = pgNo;
            }
        }

        if (pgNo != "1" && (document.URL.indexOf("page=").length <= 0 || window.location.hash.length > 0)) {
            window.location.hash = compress($("form#FilterForm").closest("form").serialize() + "&p=" + pgNo);
        }

    }
    else if ($("form#FilterForm").length > 0 && locationHashValue != "") {

        //change params on refresh
        var paramF = GetHashParamValue("f");

        if (paramF == "") {
            paramF = "&f=1";
        }
        else {
            paramF = "&f=" + (Number(paramF) + 1);
        }

        var curHash = locationHashValue.split("&f=")[0] + paramF;

        window.location.hash = curHash;
    }

    $('.Pages a').live("click", function (e) {

        $curPage = $(this);

        if (IsAutoScrollOpen) {
            //$nextPage = $('.Pages a.selected').next(); 
            //$('.Pages a').removeClass("selected");
            //$nextPage.addClass("selected");
        } else {
            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top + -90
            }, 500);
        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if ($("#CombineList").length > 0) {
            window.location.hash = "p=" + $curPage.attr("data-pgno");
        }
        else {

            pgNo = $curPage.attr("data-pgno");
            var orderTypeNo;
            var ordertypeval;
            if (IsAutoScrollOpen) {

                var paramPgNo = GetHashParamValue("p");
                var paramOrderType = GetHashParamValue("o");

                if (paramPgNo != undefined && paramPgNo.length > 0) {
                    orderTypeNo = Number(paramPgNo) + 1;
                }
                if (window.location.hash.split("o=")[1] != "" && window.location.hash.split("o=")[1] != undefined) {
                    ordertypeval = Number(window.location.hash.split("o=")[1].split("&")[0]);
                    orderTypeNo = "&o=" + ordertypeval;
                }
            }
            if (Number(window.location.hash.indexOf("o=")) == -1) {
                window.location.hash = compress($("form#FilterForm").serialize()) + "&p=" + pgNo;
            } else {
                window.location.hash = compress($("form#FilterForm").serialize()) + "&p=" + pgNo + orderTypeNo;
            }
        }

        e.preventDefault;
        return false;
    });

    $('#GridIcons #u').live("change", function () {

        if (IsAutoScrollOpen == false) {
            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top
            }, 500);
        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        $curPage(".Pages a.selected");

        pgNo = $curPage.attr("data-pgno");

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = Number(paramPgNo);
            }
        }

        window.location.hash = compress($("form#FilterForm").serialize()) + "&p=" + pgNo;
    });

    //$(".filterLink").on("click", function () {

    //    $(".FilterBoxes").not($(this).next(".FilterBoxes")).hide();
    //    $(this).next(".FilterBoxes").toggle();

    //    if ($(this).closest(".FilterSortBy").length > 0) {
    //        $(this).next(".FilterBoxes").toggle();
    //    }
    //});

    //$(".filterLink").live("click",function (e) {

    //    $(".FilterBoxes").not($(this).next(".FilterBoxes")).slideUp("fast");
    //    $(this).next(".FilterBoxes").slideToggle("fast");

    //    if ($(this).closest(".FilterSortBy").length > 0) {
    //        $(this).next(".FilterBoxes").toggle("fast");
    //    }
    //});

    //var hs1 = window.location.hash;

    //if ($("form#FilterForm").length <= 0 && location.href.indexOf("ct=") != -1) {

    //    if (hs1 == "#_=_") {
    //        window.location.hash = "";
    //        document.location.href = "";
    //    }

    //    hs1 = hs1.replace("#", "");

    //    if ($('"#' + hs1 + '"').length > 0) {
    //        $("#ContactMap, #ContactInfo, #ContactForm").hide();

    //        $("#" + hs1 + "").show("slow");
    //    }
    //}

    //$('.ToogleFilters').on('click', function (e, index) {
    //    $(".FilterForm").toggleClass("ShowFilters");
    //    $(this).toggleClass("active");
    //});

    $("section.FilterOption ul>li>input[type=checkbox]").live("change", function () {
        if ($(this).is(':checked')) {
            $(this).next("label").addClass("checked");
        }
        else {
            $(this).next("label").removeClass("checked");
        }
    });

    if ($("ul#ColorFilters>li>label").exists) {

        $("ul#ColorFilters>li>label.Colored").each(function () {
            var c = $(this).css("background-color");
            var xColor = [];
            if (c.length <= 7) {
                xColor = [hexToRgb(c).r, hexToRgb(c).g, hexToRgb(c).b];
            }
            else {
                xColor = c.replace(/^(rgb|rgba)\(/, '').replace(/\)$/, '').replace(/\s/g, '').split(',');
            }

            $(this).css("color", RenkKontrol(xColor) ? "white" : "black");
        });
    }

    //if ($("input#prc").length > 0) {
    //    var vlDefault = $("input#prc").attr("data-slider-value").replace("[", "").replace("]", "").split(",");

    //    $("input#prc").attr("value", vlDefault[0] + '-' + vlDefault[1]);

    //    $("#prc").slider({
    //        //formater: function (value) {
    //        //    return '<span class="TL">' + $(".TL").first().html() + ' </span>' + value;
    //        //}
    //    });

    //    $("#prc").slider().on('slideStop', function (ev) {

    //        var vl = $("input#prc").val().split(",");

    //        $("input#prc").attr("value", vl[0] + '-' + vl[1]);
    //        $("input#prc").attr("value", $("input#prc").attr("value").replace("-undefined", ""));

    //        if ($(".CurMinPrice").length > 0) {

    //            var curCode = $(".CurValues").data("code");

    //            $(".CurMinPrice").text(vl[0] + " " + curCode);
    //            $(".CurMaxPrice").text(vl[1] + " " + curCode);
    //        }

    //        window.location.hash = compress($("form#FilterForm").serialize());

    //        if (IsAutoScrollOpen == false) {


    //            if ($("div.row-fluid.Products").length > 0) {
    //                $('html, body').animate({
    //                    scrollTop: $("div.row-fluid.Products").offset().top + -130
    //                }, 500);

    //            }
    //            else if ($("div.row.Products").length > 0) {
    //                $('html, body').animate({
    //                    scrollTop: $("div.row.Products").offset().top + -130
    //                }, 500);
    //            }
    //        }
    //        else {
    //            $(".Products .ProductList.grid-wrapper").html("");
    //        }
    //    });

    //    $(".FilterOption .slider-horizontal").removeAttr("style");
    //    $(".FilterOption .slider-horizontal").width("");

    //    $("input#prc").hide();
    //}

    //if ($("input#prc").length > 0) {
    //    $("#prc").slider({
    //        formater: function (value) {
    //            return '<span class="TL">' + $(".TL").first().html() + ' </span>' + value;
    //        }
    //    });
    //}

    $('.CatShowMore').on('click', function (e, index) {
        $(this).hide();
        $('.CatShowLess').show();
        $('.CatSecondPart').show();
    });

    $('.CatShowLess').on('click', function (e, index) {
        $(this).hide();
        $('.CatShowMore').show();
        $('.CatSecondPart').hide();
    });

    if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {
        $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");
        //$(".PrdContainer .ProductList .Prd").addClass("col-xs-12");
    }

    //$curCatalog = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");
    //if ($curCatalog.length > 0) {
    //    $curUL = $curCatalog.closest("li").find("ul").first().clone();

    //    $("#SubCatNavs").html("");
    //    $("#SubCatNavs").append($curUL);

    //    $(".WithSub #SubCatNavs ul li:gt(6)").remove();
    //}

    $("#QuickLookModal .ProductSuggestHeader").live("click", function (e) {
        $("#QuickLookModal .Productsuggest").toggle();
        $("#QuickLookModal .CombineInfoPd").toggle();
    });

    $(".QuickLookBtn").live("click", function (e) {
        var ProductID = $(this).data("productid");
        var ColorID = $(this).data("colorid");

        $Modal = $("div#QuickLookModal");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
            data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
            success: function (dt) {

                $("div#QuickLookModal .modal-body").html(dt);
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");
            }
        });

        $Modal.modal("show");

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swParams = GetSwPageParams();

            swParams = ChangeSwHashedStringParamValue(swParams, "ActionType", "UrunGoruntuleme");

            swParams = AddSwParam(swParams, "ProductID", ProductID);
            swParams = AddSwParam(swParams, "ColorID", ColorID);

            swParams = AddSwParam(swParams, "SubActionType", "HizliBakis");

            AddSwAction(swParams);
        }

        return false;
        e.preventDefault();
    });

    $('.ToogleFilters').on('click', function (e, index) {
        $("#FilterForm").slideToggle(); //toggleClass("ShowFilters");
        //$(this).toggleClass("active");
    });

    $(window).scroll(function () {

        var scroltoview = isScrolledIntoView($(".Products"));

        if (scroltoview && isNewRequestAllowed) {

            $nextPg = $(".Pages:first a.selected:first").next("a");

            if ($nextPg.length > 0 && $(".ProductList .NotFound").length <= 0) {
                $nextPg.trigger("click");

            } else {
                $("#CatalogEnded").show();
                $(".ProductList .NotFound").hide();
            }
        }
    });

    $(".read-more-link").click(function (e) {
        // record if our text is expanded
        var isExpanded = $(e.target).hasClass("expand");

        //close all open paragraphs
        $(".CatDescription.expand").removeClass("expand");
        $(".read-more-link.expand").removeClass("expand");

        // if target wasn't expand, then expand it
        if (!isExpanded) {
            $(e.target).parent(".CatDescription").addClass("expand");
            $(e.target).addClass("expand");
        }
    });

    const firstAnswer = $(".faq-answer").first();
    firstAnswer.show();

    $(".faq-question").on("click", function () {
        const answer = $(this).next(".faq-answer");
        const allAnswers = $(".faq-answer");

        allAnswers.not(answer).slideUp();
        answer.slideToggle();
    });


    // Filtre menüsünde kategori seçildiğinde çalıştırılan fonksiyon
    //$('#SubCatNavsNew a').live('click', function () {
    //    var hrefValue = $(this).attr('data-href');    

    //    var lastCatUrl = "";
    //    var urlSplit = window.location.href.split("#")[0].split("/");
    //    var splittextCount = urlSplit.length;

    //    var isnumber = Number.isInteger(parseInt(window.location.href.split("#")[0].split("/")[splittextCount - 1]));
    //});

    // Mobil filtre menüsü top değeri ayarlamak için
    if ($(window).width() < 991) {
        var toggleFilter = document.querySelector('.ToogleFilters');
        var filterForm = document.querySelector('.FilterForm');

        if (toggleFilter && filterForm) {
            var scrollTop = window.scrollY || window.pageYOffset;

            var toggleFilterOffsetTop = toggleFilter.offsetTop;

            var newTop = toggleFilterOffsetTop - scrollTop;

            filterForm.style.top = newTop + 43 + 'px';
        }
    }

});


// Bu fonksiyon kullanılmadıi kaldırılması gerekebilir
//function FilterRefresh() {
//    $.ajax({
//        type: 'get',
//        url: "/" + $("#SmallLangCode").val() + "/p/Cat/CatFilter",
//        data: compress($(".FilterForm").serialize()),
//        success: function (dt) {
//            $("#LeftWrapper").html(dt);
//            GetLeftCatalogList(); // İlk kategori filtresi
//            SetPriceSlider();
//        }
//    })

//function AddToBasket() {
//    $(".Prd .AddToCart").live("click", function () {
//        console.log("CategoryAndFilters");

//        var SizeID = $(this).data("sizeid");
//        var ColorID = $(this).data("colorid");
//        var ProductID = $(this).data("productid");
//        var LangID = $("#LangID").val();
//        var Amount = 1;

//        $.ajax({
//            type: 'get',
//            url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
//            data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
//            dataType: 'json',
//            async: true,
//            success: function (dt) {

//                if (dt.Sonuc == true) {

//                    $Modal = $("div#QuickLookModal");

//                    if ($Modal.length > 0) {
//                        $Modal.modal("hide");
//                    }

//                    $.ajax({
//                        type: 'get',
//                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
//                        data: "",
//                        async: true,
//                        contentType: "application/json; charset=utf-8",
//                        dataType: 'text',
//                        success: function (dt) {

//                            $("#UserMenus > #UserAndBasket").html(dt);

//                            $('html, body').animate({ scrollTop: 0 }, 'slow');

//                            $(".RightBasket").addClass("active");
//                            $("body").addClass("BackDropped");

//                            $(".SepetProducts").hide();
//                            $(".SepetButton a").trigger("click");
//                        }
//                    });

//                    if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

//                        var basketParams = GetSwPageParams();

//                        basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
//                        basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
//                        basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
//                        basketParams += "&CatalogID=" + $("#CurCatalogID").val();

//                        AddSwAction(basketParams);
//                    }

//                    if (UseTagManager) {

//                        SendCartAddEvent('');
//                    }
//                }
//                else {

//                    alert(dt.IslemSonucAciklama);
//                }
//            }
//        });
//    });
//}